
import Confetti from './confetti.js';

export default class LearnDash {
    constructor() {
        this.modifyWpProQuizResults();
        this.lessonsClickTooltip();
        this.startTheCourse();
        this.completeLesson();
        this.activateConfetti();
    }
    modifyWpProQuizResults() {
       jQuery(document).ready(function($) {
           $(document).ajaxSuccess(function(event, xhr, settings) {
               if (settings.url.indexOf('wp-admin/admin-ajax.php') !== -1 && settings.data && settings.data.includes('wp_pro_quiz_completed_quiz')) {
                   setTimeout(function() {
                       let resultsElement = $('.wpProQuiz_results > p:has(.wpProQuiz_correct_answer)');

                       if (resultsElement.length > 0) {
                           let correctAnswers = parseInt(resultsElement.find('.wpProQuiz_correct_answer').text()) || 0;
                           let totalQuestions = parseInt(resultsElement.find('span:nth-child(2)').text()) || 0;

                           if (AssetsPath) {
                               let percentage = Math.round((correctAnswers / totalQuestions) * 100);
                               let resultText = AssetsPath.translations.quizResultsDataText
                                   .replace('{correct}', correctAnswers)
                                   .replace('{total}', totalQuestions)
                                   .replace('{percentage}', percentage);

                               resultsElement.text(resultText);
                           }
                       }
                   }, 500);
               }
           });
       });
   }

    lessonsClickTooltip() {
        let hoverBox = document.querySelector('.lessons_login-message');

        if (!hoverBox) return;

        // document.body.appendChild(hoverBox);

        document.querySelectorAll(".lessons_group").forEach(item => {
                item.addEventListener("click", function(e) {
                    e.stopPropagation();
                    if(hoverBox.style.display !== "block"){
                        hoverBox.style.display = "block";
                    }
                });
            });

        document.addEventListener('click', function() {
            if(hoverBox.style.display === "block") {
                hoverBox.style.display = "none";
            }
        });

        hoverBox.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    }

    getPushEngageId() {
        return new Promise((resolve, reject) => {
            PushEngage.push(function () {
                PushEngage.getSubscriberId()
                    .then(function (subscriberId) {
                        resolve(subscriberId);
                    })
                    .catch(function (err) {
                        resolve('');
                    });
            });
        });
    }

    completeLesson(){

        $('.course-top-bar-state__login').on('click', function (e){
            localStorage.setItem('courseStart', $(this).attr('data-id'));
            localStorage.setItem('courseReturn', $(this).attr('data-link'));
        })

        $('.lessons_login-message a').on('click', function (e){
            localStorage.setItem('courseStart', $(this).parents('.lessons_login-message').attr('data-id'));
            localStorage.setItem('courseReturn', $(this).parents('.lessons_login-message').attr('data-link'));
        })


        let current = this;
        $('.learndash_mark_complete_button').on('click', function (e){
            e.preventDefault();
            $(this).parents('.sfwd-mark-complete').off('submit');
            let button = $(this);
            let courseId = $(this).parents('.sfwd-mark-complete').find('input[name="course_id"]').val();
            let lessonId = $(this).parents('.sfwd-mark-complete').find('input[name="post"]').val();
            current.getPushEngageId().then(profilePush => {
                jQuery.ajax({
                    type: 'POST',
                    url : myAjax.ajaxurl,
                    data : {
                        action : 'lesson_complete',
                        course_id: courseId,
                        lesson_id: lessonId,
                        profile_id: profilePush
                    },
                    success: function (response) {
                        console.log(response);
                        button.parents('.sfwd-mark-complete').submit()
                    }
                })
            });
            // $(this).parents('.sfwd-mark-complete').submit()
        })
    }

    startTheCourse() {
        let current = this;
        $('.course-top-bar-state__start').on('click',function (e) {
            e.preventDefault();
            let courseId = $(this).data('course-id');
            current.getPushEngageId().then(profilePush => {
                jQuery.ajax({
                    type: 'POST',
                    url : myAjax.ajaxurl,
                    data : {
                        action : 'start_the_course',
                        course_id: courseId,
                        profile_id: profilePush
                    },
                    success: function (response) {
                        location.reload();
                    },
                    error: function (error) {
                        console.log('Error starting the course', error);
                    }
                })
            });
        })
    }

    activateConfetti() {
        const certificateContainers = document.querySelectorAll('[class*="learndash-shortcode-wrap-ld_certificate-"]');
        if (certificateContainers.length) {
            certificateContainers.forEach(container => {
                const confettiClass = [...container.classList].find(cls =>
                    cls.startsWith('learndash-shortcode-wrap-ld_certificate-')
                );

                if (!confettiClass) return;

                const storageKey = `confetti_seen_${confettiClass}`;

                if (!localStorage.getItem(storageKey)) {
                    Confetti.startAnimation();
                    localStorage.setItem(storageKey, 'true');
                }

            });
        }
    }


}